module.exports = __webpack_public_path__ + "static/media/trending-up.1ad37268.svg";